import { desktopBlur, type CardDirection, type FlowThemeCardMotion } from '../../cardMotion';

/**
 * Each card climbs in from below along the switchback, and the last one carries
 * on up and away.
 */
export const mountainCardMotion = (isMobile: boolean): FlowThemeCardMotion => {
  const rise = isMobile ? 64 : 84;
  const across = isMobile ? 18 : 36;
  return {
    variants: {
      enter: (direction: CardDirection) => ({
        opacity: 0,
        y: direction > 0 ? rise : -rise,
        x: direction > 0 ? across : -across,
        rotate: direction > 0 ? 1.2 : -1.2,
        filter: desktopBlur(isMobile, 6),
      }),
      center: { opacity: 1, y: 0, x: 0, rotate: 0, filter: isMobile ? undefined : 'blur(0px)' },
      exit: (direction: CardDirection) => ({
        opacity: 0,
        y: direction > 0 ? -rise * 0.7 : rise * 0.7,
        x: direction > 0 ? -across : across,
        rotate: direction > 0 ? -1.2 : 1.2,
        filter: desktopBlur(isMobile, 6),
      }),
    },
    transition: { duration: 0.85, ease: [0.22, 1, 0.36, 1] },
  };
};
